module.exports = __webpack_public_path__ + "static/media/group-8@2x.e0dbdc34.png";